/**
 * Reads a single cookie by name from `document.cookie`.
 * Returns `null` when the cookie is missing.
 */
export function getCookieValue(name: string): string | null {
  const match = document.cookie.split('; ').find((row) => row.startsWith(`${name}=`));
  if (!match) {
    return null;
  }
  const value = match.split('=')[1];
  return value === undefined ? null : decodeURIComponent(value);
}
